import Alpine from "alpinejs"
import axios from "axios"
import accessibility from "./components/alpine-accessibility"
import breakpoint from "./components/alpine-breakpoint"
import collapse from "@alpinejs/collapse"
import customization from "./components/alpine-customization"
import Livewire from "./components/alpine-livewire"
import focus from "@alpinejs/focus"
import confirm from "./components/alpine-confirm"
import cssVariable from "./components/alpine-css-variable"
import fileUpload from "./components/alpine-file-upload"
import formatters from "./components/alpine-formatters"
import modal from "./components/alpine-modal"

Alpine.plugin(accessibility)
Alpine.plugin(breakpoint)
Alpine.plugin(collapse)
Alpine.plugin(customization)
Alpine.plugin(confirm)
Alpine.plugin(cssVariable)
Alpine.plugin(focus)
Alpine.plugin(formatters)
Alpine.plugin(fileUpload)
Alpine.plugin(Livewire)
Alpine.plugin(modal)
Alpine.start()

window.Alpine = Alpine
window.axios = axios
window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest"
